import React from 'react'
import Avatar from '@mui/material/Avatar'

const getInitials = patient => {
  if (patient?.firstName) {
    return `${patient.firstName[0]}${patient.lastName?.[0] || ''}`
  }
  if (patient?.fullName) {
    return patient.fullName
      .split(' ')
      .filter(name => name.length > 0)
      .slice(0, 2)
      .map(name => name[0])
      .join('')
      .toUpperCase()
  }
  return 'P'
}

const PatientAvatar = ({ patient, size = '75px', sx }) => (
  <Avatar
    sx={{
      height: size,
      width: size,
      fontSize: parseInt(size, 10) >= 100 ? '2rem' : '20px',
      ...sx,
    }}
    alt={patient?.fullName || 'New Patient'}
    src={patient?.photo || patient?.avatarUrl}
  >
    {getInitials(patient)}
  </Avatar>
)

export default PatientAvatar
